<template>
  <v-container grid-list-xs>
    <DialogEventDetail :user="user" :event="viewEvent" @closed="detailClosed" />
    <v-card>
      <v-row>
        <v-col cols="12">
          <v-form :submit="submitSearch">
            <v-card color="grey-lighten-2">
              <v-card-title> Filtro de pesquisa
                <DialogCreateUpdateEvent :user="user" v-if="canCreate" v-model="editModel" :floatRight="true"
                                         @created="createdEvent" />
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                                  v-model="filters.searchText"
                                  label="Nome"
                                  clearable
                                  density="compact"
                                  hide-details></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" align-self="start">
                    <v-row align="start" density="compact">
                      <v-col cols="12" md="2">
                        <v-label>Data</v-label>
                      </v-col>
                      <v-col cols="12" md="5">
                        <v-text-field type="date" label="De" density="compact" v-model="filters.date_from">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="5">
                        <v-text-field type="date" label="Até" density="compact" v-model="filters.date_to">
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="12" sm="4" md="3">
                    <v-select
                              :items="[50, 100, 200, 500]"
                              v-model="filters.itemsPerPage"
                              label="Resultados por página"
                              density="compact"
                              hide-details></v-select>
                  </v-col>
                </v-row>
                <v-card-actions>
                  <v-btn color="warning" @click="clearFilters()"><v-icon class="mr-2">mdi-broom</v-icon>Limpar
                    pesquisa</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" type="submit">
                    <v-icon class="mr-2">mdi-magnify</v-icon>
                    Pesquisar
                  </v-btn>
                </v-card-actions>
              </v-card-text>
            </v-card>
          </v-form>
        </v-col>
        <v-col cols="12">
          <v-card>
            <v-card-title>
              Eventos
              <v-spacer></v-spacer>
            </v-card-title>
            <v-data-table
                          :headers="headers"
                          :items="lstObjects"
                          :search="searchFilter"
                          :items-per-page="filters.itemsPerPage"
                          return-object
                          class="elevation-1"
                          hide-default-footer>
              <template v-slot:bottom>
                <div class="text-center pt-2">
                  <v-pagination
                                :disabled="requestingApi"
                                v-model="page"
                                :length="maxPage"></v-pagination>
                </div>
              </template>
              <template v-slot:item.date="{ item }">
                <span>{{
                  $moment(item.start_date).format("DD/MM/YYYY")
                }} {{ item.start_time }}</span>
              </template>
              <template v-slot:item.actions="{ item, index }">
                <v-menu>
                  <template v-slot:activator="{ props }">
                    <v-btn icon variant="text" v-bind="props"><v-icon>mdi-dots-vertical</v-icon></v-btn>
                  </template>
                  <v-list>
                    <v-list-item v-if="canEdit" @click="editEvent(item, index)">
                      <v-list-item-title>
                        <v-icon color="primary" class="mr-2">mdi-pencil</v-icon>
                        Editar Evento
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="canDelete" @click="deleteEvent(item, index)">
                      <v-list-item-title>
                        <v-icon color="red" class="mr-2">mdi-delete</v-icon>
                        Excluir Evento</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="viewEvent = item">
                      <v-list-item-title>
                        <v-icon color="primary" class="mr-2">mdi-eye</v-icon>
                        Visualizar Evento
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>
<script>

import DialogEventDetail from '@/components/DialogEventDetail.vue';
import DialogCreateUpdateEvent from '@/components/DialogCreateUpdateEvent.vue';
import api from '@/services'

export default {
  components: {
    DialogEventDetail,
    DialogCreateUpdateEvent,
  },
  props: {
    user: Object,
  },
  data() {
    return {
      viewEvent: null,
      requestingApi: false,
      headers: [
        { title: "Nome", align: "start", key: "name", sortable: true },
        { title: "Data", key: "date", sortable: true },
        { title: "", key: "actions", align: "end", sortable: false },
      ],
      lstObjects: [],
      editModel: {},
      filters: {
        itemsPerPage: 1,
        date_from: null,
        date_to: null
      },
      searchFilter: null,
      page: 1,
      maxPage: 1,
    };
  },
  created() {
    var vm = this;

    vm.loadParameters();
  },
  mounted() { },
  activated() { },
  methods: {
    loadParameters() {
      var vm = this;
      let _itemsPerPage = localStorage["_events_itemsPerPage"];

      vm.filters.itemsPerPage = parseInt(_itemsPerPage || 10);
    },
    clearFilters() {
      var vm = this;
      vm.filters.searchText = null;
      vm.filters.date_from = null;
      vm.filters.date_to = null;
      vm.searchFilter = null;
    },
    detailClosed() {
      const vm = this;

      vm.viewEvent = null;
    },
    createdEvent(event) {
      var vm = this
      vm.lstObjects.unshift(event)
    },
    editEvent(event, index) {
      var vm = this
      vm.editModel = event
    },
    deleteEvent(event, index) {
      var vm = this
      let _confirm = confirm(
        `Deseja realmente escluir o evento ${event.name}`
      );
      if (_confirm) {
        vm.requestingApi = true;
        return new Promise((resolve, reject) => {
          api.event
            .delete(event.id)
            .then((result) => {
              vm.lstObjects.splice(index, 1);
              vm.$notify({
                type: "success",
                text: "Evento excluido",
              });
            })
            .catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
              }
            })
            .finally(() => {
              vm.requestingApi = false;
            });
        });
      }
    },
    submitSearch(page) {
      var vm = this;
      if (!vm.requestingApi) {
        vm.requestingApi = true;
        vm.page = page || 1;
        return new Promise((resolve, reject) => {
          api.event
            .list(
              {
                ...vm.filters,
                sub_group_id: vm.subGroup?.id,
              },
              page || 1
            )
            .then((result) => {
              result?.data.forEach(event => {
                event.start_date = event.start_date ? event.start_date.split('T')[0] : null
                event.end_date = event.end_date ? event.end_date.split('T')[0] : null
                event.arrival_point_date = event.arrival_point_date ? event.arrival_point_date.split('T')[0] : null
                event.exit_point_date = event.exit_point_date ? event.exit_point_date.split('T')[0] : null
              });
              vm.lstObjects = result?.data
              vm.maxPage = Math.ceil(
                (result?.total || 1) / (result?.per_page || 10)
              );
              vm.$notify({
                type: "success",
                text: "Pesquisa concluída",
              });
            })
            .catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
              }
            })
            .finally(() => {
              vm.requestingApi = false;
            });
        });
      }
    },
  },
  computed: {
    canCreate() {
      return this.user.access_level >= this.$USER_ACCESS_LEVELS_DIC.CHIEF.value;
    },
    canEdit() {
      return this.user.access_level >= this.$USER_ACCESS_LEVELS_DIC.CHIEF.value;
    },
    canDelete() {
      return this.user.access_level >= this.$USER_ACCESS_LEVELS_DIC.GROUP_ADMIN.value;
    },
    lstCustomObjects() {
      var vm = this;
      let _customLst = [];
      vm.lstObjects.forEach((obj) => {
        let customName = `${obj.name} ${obj.ssn ? "-" + obj.ssn : ""}`;
        _customLst.push({
          customName,
          ...obj,
        });
      });
      return _customLst;
    },
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {
    "filters.itemsPerPage"(newVal) {
      localStorage["_events_itemsPerPage"] = newVal;
    },
    page(newVal) {
      var vm = this;
      if (!isNaN(newVal)) {
        vm.submitSearch(newVal);
      }
    },
  },
};
</script>